import React from "react";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { DataGrid } from "@mui/x-data-grid";
import ReuseableButton from "../../../components/Buttons/button";
import { userColumns } from "./roomTypeCloumn";
import useRoomTypeTableHook from "./roomTypeTableHook";

const RoomTypeTable = () => {
    const { roomTypeState, handleDelete, handleAddRooms, loader } = useRoomTypeTableHook();

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <div
              className="deleteButton"
              onClick={(e) => handleDelete(e, params.row)}
              >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className='d-flex justify-content-end'>
        <div className="mr-5">
          <ReuseableButton
            text={"Add Rooms"}
            height={45}
            colorVarient="success"
            fullWidthFlag={true}
            endIcon={<PersonAddAltIcon />}
            handleChange={handleAddRooms}
          />
        </div>
      </div>
      <div className="datatable">
        <DataGrid
          checkboxSelection={false}
          className="datagrid"
          rows={roomTypeState?.length > 0 ? roomTypeState : []}
          columns={userColumns.concat(actionColumn)}
          rowsPerPageOptions={[10]}
          getRowId={(row) => row.uniqueId}
          loading={loader ? loader : false}
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
        //   onPageChange={(newPageSize) => handlePagination(newPageSize)}
          initialState={roomTypeState}
          pagination
          pageSize={10}
          disableColumnMenu={true}
        />
      </div>
    </>
  )
}

export default RoomTypeTable;
